import apiClient from './api_client_requests';

export default config => {
    return async payload => {
        let result = await apiClient(config).apiMethod({
            method: 'PlayerLogin',
            args: {
                form_submitted: 1,
                email: payload.email,
                password: payload.password,
                promotion: config.promotion,
                terms_check: true,
            },
        });

        let player = result.user;
        let loggedIn = player ? true : false;
        if (loggedIn) {
            return {
                loggedIn: loggedIn,
                player: {
                    name: player.first_name + ' ' + player.last_name,
                    email: player.email,
                    first_name: player.first_name,
                    last_name: player.last_name,
                    email_confirm: player.email,
                },
            };
        } else if (result.response) {
            return {
                loggedIn: false,
                errors: result.response.message,
            };
        } else {
            return {
                loggedIn: false,
                errors: 'Unspecified Error',
            };
        }
    };
};
